module.exports = __webpack_public_path__ + "img/shanghaiyh.6243b2b6.png";